import React from 'react';
import { Input as ChakraInput, InputProps as ChakraInputProps } from '@chakra-ui/react';
import { normalizeInputChangeEvent } from '../../../helpers/normalizeInputChangeEvent';
import { NormalizedInput } from './NormalizedInput';

export const Input = React.forwardRef<HTMLInputElement, ChakraInputProps & NormalizedInput>((props, ref) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!props.onChange) return;

    if (!props.shouldNormalize) {
      props.onChange(e);
      return;
    }

    props.onChange(normalizeInputChangeEvent(e));
  };

  return <ChakraInput ref={ref} {...props} onChange={handleChange} />;
});

Input.displayName = 'Input';
